import { FavoritesScreen } from '@/features/favorites/FavoritesScreen';

export function FavoritesPage() {
  return (
    <main className="flex flex-col">
      <h1 className="px-6 pt-8 font-display text-h1 text-text">Избранное</h1>
      <FavoritesScreen />
    </main>
  );
}
